<template>
	<div id="message_list">
		<div class="message_list">
			<div class="message_list1">
				<div class="message_list2 flex-row cursor_1" @click="toNovellist">
					<img src="@/assets/image/icon_right.png" alt="">
					购买课堂记录
				</div>
			</div>

			<div class="history_list" v-if="list.length == 0">
				<noData></noData>
			</div>
			<div class="history_list" ref="scrollContainer" v-else>
				<div v-for="(item, i) in list" :key="i" class="history_item" @click="toDetail(item.courseId)">
					<p style="font-size: 18px;color: #000;">{{ item.title }}</p>
					<div class="flex-row" style="color: #8f8f8f;font-size: 14px;padding: 0.5rem 0;">
						<p >
							<span>购买时间：</span><span>{{ item.buyTime }}</span>
						</p>
						<p>
							<span class="t-m-l-20">购买价格：￥{{ item.price }}</span>
						</p>
					</div>
					<div class="flex-row" style="justify-content: space-between;">
						<p class="flex-row" >
							<img :src="item.mentorHead" width="40" height="40"  /><span class="t-m-l-10">{{ item.mentorName }}</span>
						</p>
						<p>
							<el-button type="text" @click.stop="toDetail(item.courseId)">查看详情</el-button>
						</p>
					</div>
				</div>
				<div ref="loader" class="loader">
					<div v-if="loading">加载中...</div>
					<div v-if="!hasMore">没有更多数据了</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/api/api';
import CApi from '@/api/classroom'
import noData from '@/components/no_data.vue';
import { scrollerMixin } from '@/mixin/scrollerMixin';
export default {
	mixins: [scrollerMixin],
	components: {
		noData
	},
	data() {
		return {
			title: [],
			titleIndex: 0,
			type: '',
			list: [],
			total: 0,
			pageNum: 1,
			pageSize: 16,
			levels:[],
		}
	},
	created() {
		this.levelList()
		this.loadItems()
	},
	watch: {
		// 监听 list 变化，数据加载完成后初始化观察器
		list() {
			this.$nextTick().then(_ => {
				this.initObserver({
					scrollRequest: () => {
						this.loadItems()
					}
				})
			})
		}
	},
	methods: {
		toNovellist(){
            this.$router.go(-1)
		},
		levelList(){
			CApi.levelsList().then(res=>{
				if(res.code === 200){
                    this.levels = res.data
				}
			})
		},
		levelName(level){
		  console.log('level=',this.levels)
          const levelObj = this.levels.find(item=> item.level == level)
          if(Object.keys(levelObj).length > 0){
            return levelObj.name
		  }
		  return '未知类型'
		},
		async loadItems() {
			this.loading = true;
			try {
				const response = await CApi.classroomBuyHistory({ pageNum: this.pageNum, pageSize: this.pageSize });
				console.log('response=', response)
				if (response.code === 200) {
					this.list = [...this.list, ...response.data];
					this.pageNum++;
					this.hasMore = response.data.length >= this.pageSize;
				} else {
					this.$message.warning(response.msg)
				}

			} catch (error) {
				console.error('滚动分页出现问题:', error);
			} finally {
				this.loading = false;
			}
		},
		//去详情
		toDetail(id) {
			 this.$router.push({ path: '/classroom_detail', query: { detailId: id,bought:true } })
		},
	}
}
</script>
<style lang="scss" scoped>
p{
	margin: 0;
	padding: 0;
}
#message_list {
	flex: 1;
	height: 100%;
	padding: 16px 0 0 20px;
	display: flex;
	flex-direction: column;
}

.message_list {
	flex: 1;
	width: 100%;
	height: 100%;
	background-color: #FFFFFF;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	margin-bottom: 15px;
	border-radius: 10px;
}

.message_list1 {
	padding: 20px;
	border-bottom: 1px solid #E6EBF0;
}

.message_list2 {
	font-weight: bold;
	font-size: 18px;
	color: #0B0B0B;
}

.history_list{
	height: 100%;
	display: flex;
	flex-direction: column;
	.history_item{
		margin:0 2rem;
		padding: 0.7rem 0;
		position: relative;
		box-sizing: border-box;
		border-bottom:1px solid var(--tech-btn-border2) ;
	}
}

.loader {
	font-size: 16px !important;
}
</style>